// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1boIv","inputWrap":"Table_inputWrap__1T1df","col":"Table_col__20Oa7","bmiTooltip":"Table_bmiTooltip__2cxcD"};